import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';

const Dropdown = ({
  id,
  selected,
  onSelect,
  caption,
  showCaption,
  children,
  disabled,
  className,
  style,
  dataTestId,
}) => {
  const { t } = useTranslation();
  function handleChange(e) {
    const {
      target: { value },
    } = e;
    onSelect(value);
  }

  return (
    <select
      id={id}
      className={getClassName(className)}
      style={style}
      disabled={disabled}
      onChange={handleChange}
      value={selected}
      data-testid={dataTestId || 'dropdown'}
    >
      {showCaption && (
        <option data-testid="option-d881bdd3" key={0} value="">
          {caption === 'Select' ? t('SELECT') : caption}
        </option>
      )}
      {children}
    </select>
  );
};

Dropdown.propTypes = {
  id: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.array,
  caption: PropTypes.string,
  showCaption: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  style: PropTypes.object,
};

Dropdown.defaultProps = {
  caption: 'Select',
  showCaption: true,
  className: {},
  style: {},
};

export default Dropdown;
